// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Backdrop,
//   Button,
//   DetailCard,
//   Drawer,
//   FormFieldSet,
//   InfoTextAdv,
//   LogoLoader,
//   showToast,
// } from "../../../../../components";
// import { addCandidateNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
// import { getNotes, deleteNote } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
// import { addNoteToApplicant, updateAllSourceNotes, updateApplicantNotesList } from "../../../../../redux/slices/internalDbES/internalDbESlice";
// import { useDispatch, useSelector } from "react-redux";
// import { addNoteToApplicantBDM, updateAllOtherSourceNotes, updateApplicantNotesListBDM } from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";
// import { formatWords2 } from "../../../../../utils/stringUtils";
// import { convertFromUTC } from "../../../../../utils/dateUtils";
// import { updateApplicantNotes } from "../../../../../redux/slices/recruitmentSourcing/SourcingSlice";

// const AddNoteModal = ({ isOpen, onClose, data, source }) => {
  
//   const { user } = useSelector((state) => state?.auth);
//   const [notes, setCandidateNotes] = useState("");
//   const dispatch = useDispatch();
  
//   const [notesData, setNotesData] = useState([]);
//   const [loadingAdd, setLoadingAdd] = useState(false);

//   const uiid = source == "jobBoards" ? data?.uiid : null
//   const CandidateUiid = data?.candidateId?.uiid || uiid || data?.uiid;
//   const existingCandidateNotesList = useSelector((state) => {
//   const slice = state.internalDbES;
//   const sourceMap = {
//     1: Array.isArray(slice.totalApplicantsData)
//       ? slice.totalApplicantsData
//       : slice.totalApplicantsData?.data || [],
//     2: slice.careerBuilder?.existingCandidates || [],
//     3: slice.monster?.existingCandidates || [],
//   };
//   const list = source ? sourceMap[source] || [] : [];
//   let candidate = list.find(
//     (c) => String(c?.uiid) === String(CandidateUiid)
//   );
//   if (!candidate) {
//     const bdm = state.bdmJobs || {};
//     const fallbackLists = [
//       bdm.pipeline?.data,
//       bdm.confirmedOrStart?.data,
//       bdm.followupInterviews?.data,
//       bdm.clientsubmissions?.data,
//     ];
//     for (const arr of fallbackLists) {
//       if (!Array.isArray(arr)) continue;
//       candidate = arr.find(
//         (c) =>
//           String(c?.candidateId?.uiid) ===
//           String(CandidateUiid)
//       );
//       if (candidate) break;
//     }
//   }
//   return [...(candidate?.notesList ?? [])];
// });

// //   const fetchNotes = async () => {
// //     if (!CandidateUiid) {
// //       setNotesData([]);
// //       showToast("No Candidate id", "warning", 2000);
// //       return;
// //     }
// //      setLoadingAdd(true);
// //     try {
// //       const res = await getNotes({
// //         coll: "Note",
// //         filters: { candidateId: { type: "NONE", value: CandidateUiid } },
// //         lim: 10,
// //         pg: 1,
// //         extret: "uiid firstName",
// //         ret: "uiid note addedBy addedOn",
// //         sort: { addedOn: -1 },
// //       });
// // setLoadingAdd(false);
// //       if (res?.data?.data) {
// //         const applicantId = CandidateUiid;
// //         const notes = res?.data?.data;
// //         dispatch(updateApplicantNotesList({ applicantId, notesList: notes }))
// //         dispatch(updateApplicantNotesListBDM({ applicantId, notesList: notes }))
// //         // setNotesData(res.data.data);
// //       } else {
// //         setNotesData([]);
// //       }
// //     } catch (error) {
// //       setLoadingAdd(false);
// //       console.error("Error fetching notes:", error);

// //     }
// //   };
// const fetchNotes = useCallback(async () => {
//   if (!CandidateUiid) {
//     setNotesData([]);
//     showToast("No Candidate id", "warning", 2000);
//     return;
//   }
//   setLoadingAdd(true);

//   try {
//     const res = await getNotes({
//       coll: "Note",
//       filters: {
//         candidateId: { type: "NONE", value: CandidateUiid },
//       },
//       lim: 10,
//       pg: 1,
//       extret: "uiid firstName",
//       ret: "uiid note addedBy addedOn",
//       sort: { addedOn: -1 },
//     });

//     const notes = res?.data?.data || [];

//     dispatch(updateApplicantNotesList({ applicantId: CandidateUiid, notesList: notes }));
//     dispatch(updateApplicantNotesListBDM({ applicantId: CandidateUiid, notesList: notes }));
//     if (notes.length > 0) {
//      notes.forEach((note) => {
//         const payload = {
//           applicantId: CandidateUiid,
//           uiid: note.uiid,
//           newNoteUiid: note.uiid,
//           note: note.note,
//           addedBy: note.addedBy,
//           addedOn: note.addedOn,
//         };
//         dispatch(updateApplicantNotes(payload));        // sourcing
//         dispatch(updateAllSourceNotes(payload));        // internalDbES
//         dispatch(updateAllOtherSourceNotes(payload));   // bdmJobs
//       });
//     }
//   } catch (error) {
//     console.error("Error fetching notes:", error);
//   } finally {
//     setLoadingAdd(false);
//   }
// }, [CandidateUiid, dispatch]);
//   useEffect(() => {
//   if (!isOpen) return;
//   fetchNotes();
// }, [isOpen, fetchNotes]);

//   // useEffect(() => { }, [existingCandidateNotesList])

//   const handleAddNotes = async () => {
//     if (!notes?.trim()) {
//       showToast("Please Enter Notes", "error", 2000);
//       return;
//     }
//     setLoadingAdd(true);
//     try {

//       const res = await addCandidateNotes({
//         coll: "Note",
//         postActions: ["updateSource"],
//         payload: {
//           addedBy: user?.data?.uiid,
//           candidateId: CandidateUiid,
//           note: notes,
//           source: 2,
//         },
//       });

//       if (res?.data?.data) {
//         setCandidateNotes("");
//         showToast("Notes Added Successfully", "success", 2000)
//         // await fetchNotes();
//         const data = res?.data?.data || {}
//         dispatch(updateAllSourceNotes({ applicantId: data?.candidateId, newNoteUiid: data?.uiid, uiid: data?.uiid,
//             note: data?.note,
//             addedBy: data?.addedBy,
//             addedOn: data?.addedOn }))
//         if (!source || source != "jobBoards") {
//           dispatch(updateAllOtherSourceNotes({ applicantId: data?.candidateId, newNoteUiid: data?.uiid, uiid: data?.uiid,
//             note: data?.note,
//             addedBy: data?.addedBy,
//             addedOn: data?.addedOn }))
//         }
//         dispatch(addNoteToApplicant({ applicantId: CandidateUiid, note: data?.note, addedBy: data?.addedBy, addedOn: data?.addedOn, uiid: data?.uiid }))
//         dispatch(addNoteToApplicantBDM({ applicantId: CandidateUiid, note: data?.note, addedBy: data?.addedBy, addedOn: data?.addedOn, uiid: data?.uiid }))
//       } else {

//         console.warn("Add note did not return expected data:", res);
//       }
//     } catch (error) {
//       showToast("Error Adding Notes", "error", 2000)
//       console.error("Error adding notes:", error);

//     } finally {
//       setLoadingAdd(false);
//     }
//   };


//   const handleDeleteNote = async (id) => {
//     await deleteNote({
//       coll: "Note",
//       uiid: id
//     });
//     setNotesData((prev) =>
//       prev.filter((item) => !(item.uiid === id || item._id === id))
//     );

//   };

//   const formatDateTime = (dateString) => {
//     if (!dateString) return "-";

//     const date = new Date(dateString);

//     const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
//     const formattedDate = date.toLocaleDateString("en-US", optionsDate);

//     const optionsTime = {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     };
//     const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

//     return `${formattedDate} ${formattedTime}`;
//   };

//   return (
//     <Drawer isOpen={isOpen} onClose={() => { setCandidateNotes(""); onClose?.(); }} width="w-3xl md:w-2xl" title={"Notes"}>
//       <div className="flex flex-col gap-5">
//         <FormFieldSet
//           type="textArea"
//           title="Add Note"
//           rows={5}
//           placeholder=""
//           value={notes}
//           onChange={(e) => {

//             const v = e?.target ? e.target.value : e;
//             setCandidateNotes(v);
//           }}
//         />
//         <div className="flex justify-end items-center ">
//           <Button
//             title={"Add Note"}
//             onClick={handleAddNotes}
//             icon={"add"}
//             size="sm"
//             disabled={loadingAdd || !CandidateUiid}
//           />
//         </div>

//         <div className="flex flex-col gap-3">
//           <div className="flex flex-col gap-3">
//             {(existingCandidateNotesList?.length > 0 && CandidateUiid) ? (
//               existingCandidateNotesList.map((item) => (
//                 <DetailCard
//                   key={item.uiid || item._id}
//                   size="xs"
//                   title={
//                     <div className="flex items-center gap-4 p-2">
//                       <Button type="icon" icon="business_center" variant="text" size="xl" />
//                       <InfoTextAdv
//                         title={formatWords2(item?.addedBy?.firstName || "Unknown User")}
//                         titleProps={{ className: "!text-black !text-sm font-[600]" }}
//                         value={
//                           <p className="line-clamp-1 text-primary-500 text-xs">
//                             Created on –{" "}
//                             {formatDateTime(convertFromUTC(item?.addedOn))}
//                           </p>
//                         }
//                       />
//                     </div>
//                   }
//                   headeRight={
//                     <div>
//                       {/* <Button
//                         icon="delete"
//                         variant="text"
//                         type="icon"
//                         color="black"
//                         onClick={() => handleDeleteNote(item.uiid || item._id)}
//                       /> */}
//                     </div>
//                   }
//                 >
//                   <p className="text-sm p-3">{item?.note || "-"}</p>
//                 </DetailCard>
//               ))
//             ) : (
//               <p className="text-sm text-gray-500 text-center py-4">No notes available</p>
//             )}
//           </div>
//         </div>
//       </div>
//      <Backdrop isOpen={loadingAdd} zIndex={52}>
//         <LogoLoader />
//       </Backdrop>
//     </Drawer>
//   );
// };

// export default AddNoteModal;

import React, { useState, useEffect, useCallback } from "react";
import {
  Backdrop,
  Button,
  DetailCard,
  Drawer,
  FormFieldSet,
  InfoTextAdv,
  LogoLoader,
  showToast,
} from "../../../../../components";
import { addCandidateNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { getNotes, deleteNote } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
import {
  addNoteToApplicant,
  updateAllSourceNotes,
  updateApplicantNotesList,
} from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch, useSelector } from "react-redux";
import {
  addNoteToApplicantBDM,
  updateAllOtherSourceNotes,
  updateApplicantNotesListBDM,
} from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { convertFromUTC } from "../../../../../utils/dateUtils";
import {
  updateApplicantNotes,
  updateApplicantWithNotes,
  updateApplicantsNotesArray,
} from "../../../../../redux/slices/recruitmentSourcing/SourcingSlice";

const uniqueNotes = (notes = []) =>
  Array.from(
    new Map(
      (Array.isArray(notes) ? notes : []).map((note) => [
        String(note?.uiid || note?._id),
        note,
      ]),
    ).values(),
  ).sort((a, b) => new Date(b?.addedOn) - new Date(a?.addedOn));

const AddNoteModal = ({ isOpen, onClose, data, source }) => {
  const { user } = useSelector((state) => state?.auth);
  const [notes, setCandidateNotes] = useState("");
  const dispatch = useDispatch();
  const [notesData, setNotesData] = useState([]);
  const [hasFetchedNotes, setHasFetchedNotes] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);

  const CandidateUiid = data?.candidateId?.uiid || data?.candidateId || data?.uiid;
  const existingCandidateNotesList = useSelector((state) => {
    if (!CandidateUiid) return [];

    const applicantId = String(CandidateUiid);
    const noteMap = new Map();
    const mergeNotes = (notesList = []) => {
      uniqueNotes(notesList).forEach((note) => {
        noteMap.set(String(note?.uiid || note?._id), note);
      });
    };

    const sourcingCandidate = state.sourcing?.applicants?.data?.find(
      (candidate) => String(candidate?.uiid) === applicantId,
    );
    mergeNotes(sourcingCandidate?.notesList);

    const internalLists = [
      Array.isArray(state.internalDbES?.totalApplicantsData)
        ? state.internalDbES?.totalApplicantsData
        : state.internalDbES?.totalApplicantsData?.data,
      state.internalDbES?.careerBuilder?.existingCandidates,
      state.internalDbES?.monster?.existingCandidates,
    ];
    internalLists.forEach((list) => {
      if (!Array.isArray(list)) return;
      const candidate = list.find(
        (item) => String(item?.uiid) === applicantId,
      );
      mergeNotes(candidate?.notesList);
    });

    const bdmLists = [
      state.bdmJobs?.pipeline?.data,
      state.bdmJobs?.confirmedOrStart?.data,
      state.bdmJobs?.followupInterviews?.data,
      state.bdmJobs?.clientsubmissions?.data,
    ];
    bdmLists.forEach((list) => {
      if (!Array.isArray(list)) return;
      const candidate = list.find(
        (item) => String(item?.candidateId?.uiid) === applicantId,
      );
      mergeNotes(candidate?.notesList);
    });

    return uniqueNotes(Array.from(noteMap.values()));
  });

  const displayedNotes = hasFetchedNotes
    ? uniqueNotes(notesData)
    : existingCandidateNotesList;

  const syncCandidateNotes = useCallback(
    (candidateUiid, noteList) => {
      if (!candidateUiid) return;

      dispatch(updateApplicantsNotesArray({ applicantId: candidateUiid, notes: noteList }));
      dispatch(updateApplicantNotesList({ applicantId: candidateUiid, notesList: noteList }));
      dispatch(
        updateApplicantNotesListBDM({
          applicantId: candidateUiid,
          notesList: noteList,
        }),
      );
    },
    [dispatch],
  );

  const broadcastNotesSync = useCallback((candidateUiid) => {
    if (!candidateUiid) return;

    try {
      localStorage.setItem(
        "ats_notes_sync",
        JSON.stringify({
          candidateId: String(candidateUiid),
          ts: Date.now(),
        }),
      );
    } catch (error) {
      console.error("Failed to broadcast notes sync:", error);
    }
  }, []);

//   const fetchNotes = async () => {
//     if (!CandidateUiid) {
//       setNotesData([]);
//       showToast("No Candidate id", "warning", 2000);
//       return;
//     }
//      setLoadingAdd(true);
//     try {
//       const res = await getNotes({
//         coll: "Note",
//         filters: { candidateId: { type: "NONE", value: CandidateUiid } },
//         lim: 10,
//         pg: 1,
//         extret: "uiid firstName",
//         ret: "uiid note addedBy addedOn",
//         sort: { addedOn: -1 },
//       });
// setLoadingAdd(false);
//       if (res?.data?.data) {
//         const applicantId = CandidateUiid;
//         const notes = res?.data?.data;
//         dispatch(updateApplicantNotesList({ applicantId, notesList: notes }))
//         dispatch(updateApplicantNotesListBDM({ applicantId, notesList: notes }))
//         // setNotesData(res.data.data);
//       } else {
//         setNotesData([]);
//       }
//     } catch (error) {
//       setLoadingAdd(false);
//       console.error("Error fetching notes:", error);

//     }
//   };
const fetchNotes = useCallback(async () => {
  if (!CandidateUiid) {
    setNotesData([]);
    setHasFetchedNotes(true);
    return;
  }
  setLoadingAdd(true);

  try {
    const res = await getNotes({
      coll: "Note",
      filters: {
        candidateId: { type: "NONE", value: CandidateUiid },
      },
      lim: 100,
      pg: 1,
      extret: "uiid firstName",
      ret: "uiid note addedBy addedOn candidateId source",
      sort: { addedOn: -1 },
    });

    const fetchedNotes = uniqueNotes(res?.data?.data || []);
    setNotesData(fetchedNotes);
    setHasFetchedNotes(true);
    syncCandidateNotes(CandidateUiid, fetchedNotes);
  } catch (error) {
    console.error("Error fetching notes:", error);
  } finally {
    setLoadingAdd(false);
  }
}, [CandidateUiid, syncCandidateNotes]);
  useEffect(() => {
  if (!isOpen) {
    setNotesData([]);
    setHasFetchedNotes(false);
    return;
  }

  fetchNotes();
}, [isOpen, fetchNotes, CandidateUiid]);

  useEffect(() => {
    if (!isOpen || !CandidateUiid) return;

    const handleVisibilityOrFocus = () => {
      if (document.visibilityState === "visible") {
        fetchNotes();
      }
    };

    const handleStorage = (event) => {
      if (event.key !== "ats_notes_sync") return;

      try {
        const payload = JSON.parse(event.newValue || "{}");
        if (String(payload?.candidateId) === String(CandidateUiid)) {
          fetchNotes();
        }
      } catch (error) {
        console.error("Failed to parse notes sync payload:", error);
      }
    };

    window.addEventListener("focus", handleVisibilityOrFocus);
    document.addEventListener("visibilitychange", handleVisibilityOrFocus);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("focus", handleVisibilityOrFocus);
      document.removeEventListener("visibilitychange", handleVisibilityOrFocus);
      window.removeEventListener("storage", handleStorage);
    };
  }, [isOpen, CandidateUiid, fetchNotes]);

  // useEffect(() => { }, [existingCandidateNotesList])

  const handleAddNotes = async () => {
    if (!notes?.trim()) {
      showToast("Please Enter Notes", "error", 2000);
      return;
    }
    setLoadingAdd(true);
    try {

      const res = await addCandidateNotes({
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid,
          candidateId: CandidateUiid,
          note: notes,
          source: 2,
        },
      });

      if (res?.data?.data) {
        setCandidateNotes("");
        showToast("Notes Added Successfully", "success", 2000)
        const noteDoc = res?.data?.data || {};
        const payload = {
          applicantId: CandidateUiid,
          newNoteUiid: noteDoc?.uiid,
          uiid: noteDoc?.uiid,
          note: noteDoc?.note,
          addedBy: noteDoc?.addedBy,
          addedOn: noteDoc?.addedOn,
        };

        dispatch(updateApplicantNotes(payload));
        dispatch(updateApplicantWithNotes(payload));
        dispatch(updateAllSourceNotes(payload));
        dispatch(updateAllOtherSourceNotes(payload));
        dispatch(addNoteToApplicant(payload));
        dispatch(addNoteToApplicantBDM(payload));
        broadcastNotesSync(CandidateUiid);
        await fetchNotes();
      } else {

        console.warn("Add note did not return expected data:", res);
      }
    } catch (error) {
      showToast("Error Adding Notes", "error", 2000)
      console.error("Error adding notes:", error);

    } finally {
      setLoadingAdd(false);
    }
  };


  const handleDeleteNote = async (id) => {
    await deleteNote({
      coll: "Note",
      uiid: id
    });

    const updatedNotes = displayedNotes.filter(
      (item) => !(item.uiid === id || item._id === id),
    );
    setNotesData(updatedNotes);
    setHasFetchedNotes(true);
    syncCandidateNotes(CandidateUiid, updatedNotes);
    broadcastNotesSync(CandidateUiid);

  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <Drawer isOpen={isOpen} onClose={() => { setCandidateNotes(""); onClose?.(); }} width="w-3xl md:w-2xl" title={"Notes"}>
      <div className="flex flex-col gap-5">
        <FormFieldSet
          type="textArea"
          title="Add Note"
          rows={5}
          placeholder=""
          value={notes}
          onChange={(e) => {

            const v = e?.target ? e.target.value : e;
            setCandidateNotes(v);
          }}
        />
        <div className="flex justify-end items-center ">
          <Button
            title={"Add Note"}
            onClick={handleAddNotes}
            icon={"add"}
            size="sm"
            disabled={loadingAdd || !CandidateUiid}
          />
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-3">
            {(displayedNotes?.length > 0 && CandidateUiid) ? (
              displayedNotes.map((item) => (
                <DetailCard
                  key={item.uiid || item._id}
                  size="xs"
                  title={
                    <div className="flex items-center gap-4 p-2">
                      <Button type="icon" icon="business_center" variant="text" size="xl" />
                      <InfoTextAdv
                        title={formatWords2(item?.addedBy?.firstName || "Unknown User")}
                        titleProps={{ className: "!text-black !text-sm font-[600]" }}
                        value={
                          <p className="line-clamp-1 text-primary-500 text-xs">
                            Created on –{" "}
                            {formatDateTime(convertFromUTC(item?.addedOn))}
                          </p>
                        }
                      />
                    </div>
                  }
                  headeRight={
                    <div>
                      {/* <Button
                        icon="delete"
                        variant="text"
                        type="icon"
                        color="black"
                        onClick={() => handleDeleteNote(item.uiid || item._id)}
                      /> */}
                    </div>
                  }
                >
                  <p className="text-sm p-3">{item?.note || "-"}</p>
                </DetailCard>
              ))
            ) : (
              <p className="text-sm text-gray-500 text-center py-4">No notes available</p>
            )}
          </div>
        </div>
      </div>
     <Backdrop isOpen={loadingAdd} zIndex={52}>
        <LogoLoader />
      </Backdrop>
    </Drawer>
  );
};

export default AddNoteModal;
